import * as React from "react";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordion from "@mui/material/Accordion";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Divider } from "@mui/material";
import styled from "@emotion/styled";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid lightgray`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

export default function SellerDetail(props) {
  return (
    <Box sx={{ px: 2, borderRadius: "10px" }}>
      <Accordion expanded={props.status}>
        <AccordionSummary
          expandIcon={props.status ? null : <ExpandMoreIcon />}
          aria-controls='panel1a-content'
          id='panel1a-header'
        >
          {props.icon}
          <Typography
            ml={1}
            sx={{ width: "33%", flexShrink: 0, fontWeight: "bold" }}
          >
            {props.title}
          </Typography>
        </AccordionSummary>
        <Divider />
        <AccordionDetails sx={{ bgcolor: "#FBFDFF" }}>
          {props.content}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
